import { render } from "./About.vue?vue&type=template&id=3bdf38b8"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=3bdf38b8&lang=css"

import exportComponent from "/Users/admin/Work/IKENTAI_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__